<template>
<div>

  <div   v-for=" item of procs.items" style="margin:5px">

  <v-card hover style="margin:15px"  >
    <v-toolbar   :color="colors[item.selected_type].light" flat  >
      <v-toolbar-side-icon>
<div v-if="item.selected_type == 'groups'">
      <v-tooltip v-if="item.is_working=='0'" bottom   open-delay="1000" max-width="200" >
       <v-icon large slot="activator"     @click="activate(item,'1'); item.is_working='1'" >mdi-replay</v-icon>
       <span>Кликните, что бы запустить процесс</span>
      </v-tooltip>


      <v-tooltip v-if="item.is_working=='1'" bottom   open-delay="1000" max-width="200" >
       <v-icon large slot="activator" color="green"     @click="activate(item,'2'); item.is_working='2'" >mdi-stop-circle-outline</v-icon>
       <span>Кликните, что бы остановить процесс</span>
      </v-tooltip>
</div>

<div v-if="item.selected_type == 'procs'">

      <v-tooltip v-if="item.status.status=='2'" bottom   open-delay="1000" max-width="200" >
       <v-icon large slot="activator"     @click="activate(item,'1'); item.status.status='1'" >mdi-replay</v-icon>
       <span>Кликните, что бы запустить процесс</span>
      </v-tooltip>


      <v-tooltip v-if="item.status.status=='1'" bottom   open-delay="1000" max-width="200" >
       <v-icon large slot="activator" color="green"     @click="activate(item,'2'); item.status.status='2'" >mdi-stop-circle-outline</v-icon>
       <span>Кликните, что бы остановить процесс</span>
      </v-tooltip>
</div>


        </v-toolbar-side-icon>






      <v-toolbar-title    >
        <v-flex>
          <span style="cursor:pointer;color:#4A76A8;" >  {{item.name}}  </span>
          <div v-if="item.selected_type =='groups'"  style="font-size:0.7em;color:#757575"><v-icon color="green" small>mdi-information</v-icon> id{{item.real_id}} <v-icon color="green" small>mdi-account-group</v-icon> обновление сообществ </div>
          <div v-if="item.selected_type =='pages'"  style="font-size:0.7em;color:#757575"><v-icon color="#273C51" small>mdi-information</v-icon> id{{item.real_id}} <v-icon color="#273C51" small>mdi-account-multiple</v-icon> обновление страниц</div>
          <div v-if="item.selected_type =='procs'"  style="font-size:0.7em;color:#757575"><v-icon color="#7218FF" small>mdi-information</v-icon> id{{item.real_id}} <v-icon  color="#7218FF" small>mdi-content-save</v-icon> обновление процессов</div>

        </v-flex>

       </v-toolbar-title>

      <v-spacer></v-spacer>

  <v-btn v-if="item.status.status=='2'"  icon @click="procParams(item)">
  <v-tooltip top max-width="250">  <v-icon  color="#4A76A8" slot="activator"   >mdi-tune</v-icon> <span>Изменить параметры процесса</span>  </v-tooltip>
  </v-btn>

  <v-btn icon>
  <v-tooltip top max-width="250">  <v-icon color="#C46B19" slot="activator" @click="del(item)" >mdi-close</v-icon> <span> Удалить процесс</span>  </v-tooltip>
  </v-btn>
    </v-toolbar>



<v-card-text :style="{backgroundColor:colors[item.selected_type].lighter}">
  <v-divider></v-divider>
<div >

<v-layout >

<v-flex md8 style="margin-right:10px">
<div style="color:#273C51">
   <v-icon color="#FF8F18" small>mdi-flash</v-icon>
    Последние обновление: <span style="color:gray">{{item.last_update|dateFormatFull}}</span>
 </div>
<v-divider></v-divider>



<div  v-if="item.selected_type == 'groups' " style="color:#273C51">
<v-icon :color="colors[item.selected_type].base" small>mdi-account-group</v-icon>
Выбранных сообществ всего: <span style="color:gray">({{item.params.selectedGroups.length }})</span>

</div>
<div v-else-if="item.selected_type == 'pages' " style="color:#273C51">
<v-icon :color="colors[item.selected_type].base" small>mdi-account-multiple</v-icon>
Выбранных страниц всего: <span style="color:gray">{{item.params.selectedPages.length}}</span>
</div>
<div v-else style="color:#273C51">
<v-icon :color="colors[item.selected_type].base" small>mdi-content-save</v-icon>
Выбранных процессов всего: <span style="color:#4A76A8">Уточнить</span>
</div>


<v-divider v-if="item.status.status=='1'"></v-divider>

<div v-if="item.status.status=='1'" style="color:#273C51">
<v-icon color="#273C51" small>mdi-timetable</v-icon>
Время работы:<span style="color:gray;margin-right:15px"> Информация секретная</span>

<div v-if="item.selected_type == 'groups' " >
<v-icon color="#273C51" small>mdi-account-multiple-plus</v-icon>
Новые подписки:
<span style="color:green;margin-right:5px"><span v-if="item.new_traf_count.newInCount>0">+</span>{{item.new_traf_count.newInCount}}</span>
<span style="color:red"><span v-if="item.new_traf_count.newOutCount>0">-</span>{{item.new_traf_count.newOutCount}}</span>
</div>

</div>

</v-flex>


<v-flex>
<div style="color:#273C51;font-size:1.4em">
 <div v-if="item.selected_type == 'procs' ">{{item.status.description.text}}</div>
 <div v-if="item.selected_type == 'groups'">{{item.text_status}}</div>
</div>
</v-flex>

</v-layout >


</div>
</v-card-text>


  </v-card>



  </div>

</div>
</template>




<script>
import axios from 'axios'
export default {

 props: ['procs','modals' ],
 data(){
  return {

updaterInterval : true,

colors: {
  procs: {
    base: "#7218FF",
    lighter: "white",
    light: "#CAE1FC",

  },
  pages: {
    base: "#273C51",
    lighter: "white",
    light: "#D2D4FF",

  },
  groups: {
    base: "green",
    light: "#CAE1FC",
    lighter: "white",
  }
},


  }
},
methods: {

  activate(item,status){

  let paths = ''
  if(item.selected_type == 'procs'){
    paths = 'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/fastupdate/activator.php'
  } else {
    paths = 'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/fastupdate/groups_activiti_phone.php'
  }
  axios(paths, {
       method: 'POST',
       data: {
         status: status,
         proc: item
       }
     })
     .then( response => {
       this.getProcs()
     })
},
getProcs(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/fastupdate/get_procs.php', {
       method: 'GET',
       data: {
         check: 1,
       }
     })
     .then( response => {
       this.procs.items = response.data
     })
},

  procParams(item){

    this.procs.selected = item
    this.modals.params = true
  },

  del(item){
    this.modals.deleter = true
    this.procs.toDelete = item

  },

},
computed:{

},

mounted(){
 this.getProcs()
},

created(){
this.getProcs()
this.updaterInterval =    setInterval( () => {
this.getProcs()
}, 5000)
 },

beforeDestroy(){
  clearInterval(this.updaterInterval)
},

filters:{

  dateFormat(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    // return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":"+ d.getMinutes()
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }
    return  d.getHours() +":"+ mins
  },
  dateFormatFull(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }

    let secs
    if(d.getSeconds()> 9){
      secs = d.getSeconds()
    } else {
      secs = "0"+ d.getSeconds()
    }

    return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":" + mins+":"+secs

  }
},
}
</script>

<style>

</style>
